import React, { useState, useRef } from "react";
import { Paper, Box, MenuItem, Select, Button, Typography } from "@mui/material";
import StageCanvas from "./StageCanvas";

const cameraOptions = [
    { label: "Top", value: "top" },
    { label: "Left", value: "left" },
    { label: "Right", value: "right" },
    { label: "Bottom", value: "bottom" },
    { label: "NW", value: "iso1" },
    { label: "NE", value: "iso2" },
    { label: "SW", value: "iso3" },
    { label: "SE", value: "iso4" },
    { label: "Reset View", value: "reset" },
];

const ThreeDView = ({ open, image, realWidth, realHeight, grids, masks, columns, areaResults, colorList, luminaires }) => {
    const [hovered, setHovered] = useState(false);
    const [selectedView, setSelectedView] = useState("top");
    const [cameraCommand, setCameraCommand] = useState(null);
    const [savedCameraPosition, setSavedCameraPosition] = useState(null);
    const canvasRef = useRef(null);

    if (!open || !image || typeof image !== 'string' || !image.startsWith('data:image')) {
        return null;
    }

    const handleMouseDown = (e) => {
        if (e.button === 0) {
            canvasRef.current.style.cursor = "grabbing";
        } else if (e.button === 2) {
            canvasRef.current.style.cursor = "move";
        }
    };

    const handleMouseUp = () => {
        canvasRef.current.style.cursor = "grab";
    };

    return (
        <div
            style={{
                position: "fixed",
                top: "65px",
                right: "350px",
                width: hovered ? "70vw" : "360px",
                height: hovered ? "80vh" : "360px",
                transition: "all 0.4s ease-in-out",
                zIndex: 1300,
                pointerEvents: "auto",
            }}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            <Paper
                elevation={hovered ? 8 : 3}
                sx={{
                    width: "100%",
                    height: "100%",
                    overflow: "hidden",
                    padding: 1,
                    borderRadius: 2,
                    display: "flex",
                    flexDirection: "column",
                    bgcolor: "#f7f7f7",
                }}
            >

                {hovered && (
                    <Box
                        sx={{
                            position: "absolute",
                            bottom: 8,
                            right: 8,
                            zIndex: 10,
                            fontSize: "12px",
                            backgroundColor: "rgba(0,0,0,0.6)",
                            color: "#fff",
                            px: 1.5,
                            py: 0.5,
                            borderRadius: 1,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-end",
                        }}
                    >
                        <div>🖱️ Left Click: Orbit</div>
                        <div>🖱️ Right Click: Pan</div>
                        <div>🖱️ Scroll: Zoom</div>
                    </Box>
                )}


                <Box sx={{ display: "flex", gap: 1, mb: 1, alignItems: "center" }}>
                    <Typography variant="body2">View:</Typography>
                    <Select
                        size="small"
                        value={selectedView}
                        onChange={(e) => setSelectedView(e.target.value)}
                        sx={{ minWidth: 140 }}
                    >
                        {cameraOptions.map((opt) => (
                            <MenuItem key={opt.value} value={opt.value}>
                                {opt.label}
                            </MenuItem>
                        ))}
                    </Select>
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={() => setCameraCommand(selectedView)}
                    >
                        Apply
                    </Button>
                </Box>

                <Box sx={{ flexGrow: 1 }}>
                    <Box
                        sx={{ outline: "1px solid #ccc", borderRadius: 1, width: "100%", height: hovered ? "100%" : "295px", bgcolor: "#fff" }}
                        ref={canvasRef}
                        onMouseDown={handleMouseDown}
                        onMouseUp={handleMouseUp}
                    >
                        <StageCanvas
                            image={image}
                            realWidth={realWidth}
                            realHeight={realHeight}
                            savedCameraPosition={savedCameraPosition}
                            setSavedCameraPosition={setSavedCameraPosition}
                            grids={grids}
                            masks={masks}
                            columns={columns}
                            cameraCommand={cameraCommand}
                            setCameraCommand={setCameraCommand}
                            areaResults={areaResults}
                            colorList={colorList}
                            luminaires={luminaires}
                        />
                    </Box>
                </Box>
            </Paper>
        </div>
    );
};

export default ThreeDView;
